import * as React from 'react';
import * as program from "./style.module.scss";
export const Program = () => {
  return (
    <section className={program.program} id={'program'}>
      <div className={'container'}>
        <h2 className={program.program__title}>Программа онлайн-тренинга</h2>
        <div className={program.program__wrap}>
          <div className={`${program.program__card} ${program.program__cardOne}`}>
            <h3 className={program.program__subtitle}>Работа с&nbsp;вашим языком и&nbsp;вашими темами</h3>
            <ul className={program.program__list}>
              <li className={program.program__item}>Мы&nbsp;построим ваш индивидуальный образовательный маршрут</li>
              <li className={program.program__item}>Теория любого языка</li>
              <li className={program.program__item}>Как подобрать материалы для самостоятельной отработки</li>
              <li className={program.program__item}>
                Майнд-карты вместо разговорника: как составить список необходимых слов с&nbsp;помощью майнд-карты
              </li>
              <li className={program.program__item}>Как поддерживать мотивацию при изучении языка</li>
            </ul>
          </div>

          <div className={`${program.program__card} ${program.program__cardTwo}`}>
            <h3 className={program.program__subtitle}>
              Звуки и&nbsp;буквы:
              <br />
              как учить?
            </h3>
            <ul className={program.program__list}>
              <li className={program.program__item}>Как читать на&nbsp;иностранном языке</li>
              <li className={program.program__item}>
                Как правильно произносить иностранные слова, особенности местных акцентов
              </li>
              <li className={program.program__item}>Как избавиться от&nbsp;акцента</li>
              <li className={program.program__item}>Как быстро запомнить все транскрипционные знаки</li>
              <li className={program.program__item}>Как выучить алфавит</li>
            </ul>
          </div>

          <div className={`${program.program__card} ${program.program__cardThree}`}>
            <h3 className={program.program__subtitle}>Слова&nbsp;&mdash; запоминаем 100 слов в&nbsp;час:</h3>
            <ul className={program.program__list}>
              <li className={program.program__item}>Как быстро запоминать иностранные слова без зубрёжки</li>
              <li className={program.program__item}>Как учить разные части речи</li>
              <li className={program.program__item}>Как помнить все выученные слова</li>
              <li className={program.program__item}>Программы для удобного повторения слов</li>
            </ul>
          </div>

          <div className={`${program.program__card} ${program.program__cardFour}`}>
            <h3 className={program.program__subtitle}>Грамматика и&nbsp;навык разговора</h3>
            <ul className={program.program__list}>
              <li className={program.program__item}>Как понять грамматику с&nbsp;помощью майнд-карт</li>
              <li className={program.program__item}>В&nbsp;каком порядке изучать грамматику</li>
              <li className={program.program__item}>
                Как заговорить без учебников на&nbsp;иностранном языке через месяц (паттерны и&nbsp;правила
                их&nbsp;составления)
              </li>
            </ul>
          </div>

          <div className={`${program.program__card} ${program.program__cardFive}`}>
            <h3 className={program.program__subtitle}>Письменная речь и&nbsp;понимание на&nbsp;слух</h3>
            <ul className={program.program__list}>
              <li className={program.program__item}>Как писать без ошибок</li>
              <li className={program.program__item}>Как научиться писать иероглифами и&nbsp;вязью</li>
              <li className={program.program__item}>Как понимать речь на&nbsp;иностранном языке</li>
              <li className={program.program__item}>Как смотреть видео на&nbsp;иностранном языке без субтитров</li>
            </ul>
          </div>

          <div className={`${program.program__card} ${program.program__cardSix}`}>
            <h3 className={program.program__subtitle}>Упражнения для улучшения работы мозга</h3>
            <ul className={program.program__list}>
              <li className={program.program__item}>Пальцевая гимнастика</li>
              <li className={program.program__item}>Техники для улучшения концентрации внимания</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
